import { render } from "./forgotPassword.vue?vue&type=template&id=4dcaa8e6&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"

import "./forgotPassword.vue?vue&type=style&index=0&id=4dcaa8e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcaa8e6"]])

export default __exports__